import { render, staticRenderFns } from "./FormWrapperTRC.vue?vue&type=template&id=5baf50d1&"
import script from "./FormWrapperTRC.vue?vue&type=script&lang=ts&"
export * from "./FormWrapperTRC.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports